/* Where the dashboard talks to.
 *
 * Set explicitly in production, as the other two apps learned to: a same-origin
 * fallback is right behind the local proxy and silently wrong everywhere else,
 * because the SPA rewrite answers /api/v1 with this app's own HTML and a 200.
 */
const loc = typeof window === "undefined" ? null : window.location;
const host = loc?.hostname ?? "localhost";
const origin = loc?.origin ?? "http://localhost";
const secure = loc?.protocol === "https:";

export const API_URL = import.meta.env.VITE_API_URL ?? (secure ? `${origin}/api/v1` : `http://${host}:8000/v1`);
export const AUTH_URL = import.meta.env.VITE_AUTH_URL ?? (secure ? `${origin}/auth` : `http://${host}:9999`);
